import {
    Button,
    Card, CardContent, CardHeader, Typography
} from '@material-ui/core'
import { AccessAlarmOutlined, DeleteForever, Edit } from '@material-ui/icons'
import moment from 'moment'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { getEscapeRoom } from '../../services/escape-room-services'
import { buttonsStyles } from '../../styles/ButtonsStyles'
import { cardStyles } from '../../styles/CardStyles'
import { formatTimeline, invoke } from '../../utils/helper'
import { EscapeRoomDto, EscapeRoomHeaderDto, StartedGameDto } from '../../utils/types'
import { EscapeRoomDetailsModal } from '../organisms/EscapeRoomDetailsModal'

interface Props {
    escapeRoom: EscapeRoomHeaderDto
    startedGame?: StartedGameDto
    onDelete?(): void
    onEdit?(): void
}

export const EscapeRoomCardView: React.FC<Props> = ({
    escapeRoom, startedGame, onDelete, onEdit
}) => {
    const styles = cardStyles()
    const btnStyles = buttonsStyles()
    const [showDetails, setShowDetails] = React.useState(false)
    const [escapeRoomDetails, setEscapeRoomDetails] = React.useState<EscapeRoomDto>()

    const history = useHistory()

    const totalSeconds = escapeRoom.puzzles.map((pz) => pz.seconds).reduce((p, c) => p + c, 0)
    const remainingSeconds = startedGame
        && moment.duration(moment.utc(startedGame.deadlineAt).diff(moment.utc())).asSeconds()

    const start = async () => {
        setShowDetails(false)
        if (startedGame) {
            history.push({ pathname: '/spil', state: { game: startedGame } })
        } else {
            const er = escapeRoomDetails || await invoke(async () => getEscapeRoom(escapeRoom.escapeRoomId))
            history.push({ pathname: '/start-spil', state: { escapeRoom: er } })
        }
    }

    const monitor = () => {
        setShowDetails(false)
        history.push({ pathname: '/spilovervagning', state: { game: startedGame } })
    }

    const openDetails = async () => {
        if (!escapeRoomDetails) {
            await invoke(async () => {
                setEscapeRoomDetails(
                    await getEscapeRoom(escapeRoom.escapeRoomId)
                )
            })
        }

        setShowDetails(true)
    }

    return (
        <div>
            <div className={styles.iconsWrapper}>

                <div className={styles.timeWrapper}>
                    <AccessAlarmOutlined className={styles.totalTime}/>
                    {formatTimeline(totalSeconds)}

                    {!startedGame?.finishedAt && remainingSeconds && remainingSeconds > 0 && (
                        <div style={{ marginLeft: 30, display: 'flex', alignItems: 'center' }}>
                            Aktivt spil:
                            <AccessAlarmOutlined className={styles.remainingTime}/>
                            {formatTimeline(remainingSeconds!!)}
                        </div>
                    )}
                </div>
                <div className={styles.editWrapper}>
                    {onEdit && (
                        <div style={{ marginRight: 20 }} onClick={onEdit}>
                            <Edit className={styles.icon}/>
                        </div>
                    )}
                    {onDelete && (
                        <div onClick={onDelete}>
                            <DeleteForever className={styles.icon}/>
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.eRoomCard}>
                <Card style={{ borderWidth: 1, borderStyle: 'solid', borderRadius: 20 }}>
                    <CardHeader
                        style={{
                            backgroundImage:
                                `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${escapeRoom.bannerImageUri})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: 80
                        }} />
                    <CardContent style={{ padding: 20 }}>
                        <Typography style={{ fontWeight: 700, fontSize: '1.0rem' }} variant="h6">
                            {escapeRoom.title}
                        </Typography>
                        <Typography variant="body2" className={styles.descriptionText}>
                            {escapeRoom.description}
                        </Typography>
                    </CardContent>
                    <Button
                        onClick={openDetails}
                        className={btnStyles.seeEscapeRoomBtn}>
                        Se Escape Room
                    </Button>
                </Card>

                {escapeRoomDetails && (
                    <EscapeRoomDetailsModal
                        onStart={start}
                        onMonitor={monitor}
                        startedGame={startedGame}
                        escapeRoom={escapeRoomDetails}
                        open={showDetails}
                        onClose={() => setShowDetails(false)}/>
                )}
            </div>
        </div>
    )
}

EscapeRoomCardView.defaultProps = {
    onDelete: undefined,
    onEdit: undefined,
    startedGame: undefined
}
